import TrackingEventsComponent from '../../../../../../ManagementApp/wwwroot/client/src/views/components/TrackingEvents.vue';

export default TrackingEventsComponent;
